/**
 * BHADKO OTT - Vector Assets & Graphic Generator
 * Razor-sharp SVG icons, channel branding, and live broadcast frame overlays
 */

export const ICONS = {
  logo: `<img src="/assets/bhadko-logo.jpg" alt="BHADKO Logo" width="36" height="36" class="bhadko-brand-icon rounded-full" />`,

  search: `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>`,
  
  starOutline: `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`,
  
  starFilled: `<svg viewBox="0 0 24 24" width="20" height="20" fill="#F59E0B" stroke="#F59E0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>`,
  
  play: `<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><polygon points="6 4 20 12 6 20 6 4"></polygon></svg>`,
  
  pause: `<svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><rect x="6" y="4" width="4" height="16" rx="1"></rect><rect x="14" y="4" width="4" height="16" rx="1"></rect></svg>`,
  
  volumeHigh: `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>`,
  
  volumeMute: `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>`,
  
  fullscreen: `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path></svg>`,
  
  fullscreenExit: `<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path></svg>`,
  
  share: `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line></svg>`,
  
  filter: `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>`,
  
  settings: `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>`,
  
  tv: `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline></svg>`,
  
  refresh: `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>`,
  
  chevronDown: `<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>`,
  
  close: `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
  
  trash: `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>`,
  
  edit: `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>`,
  
  eye: `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>`,

  check: `<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>`
};

/**
 * Returns a channel logo SVG element based on channel ID and color
 */
export function getChannelLogoSvg(channel) {
  const color = channel.logoColor || "#FF6B00";
  const name = channel.name || "TV";
  const initial = name.charAt(0);
  
  switch (channel.badgeType) {
    case 'news':
      return `
        <svg viewBox="0 0 60 60" width="42" height="42" class="channel-logo-img">
          <rect width="60" height="60" rx="14" fill="#1E2330"/>
          <rect x="2" y="2" width="56" height="56" rx="12" fill="none" stroke="${color}" stroke-width="2"/>
          <!-- TV9 Style Red/Blue Badge with Number 9 -->
          <rect x="8" y="12" width="44" height="26" rx="6" fill="#DC2626"/>
          <text x="18" y="31" fill="#FFFFFF" font-family="'Outfit', sans-serif" font-weight="900" font-size="20">TV</text>
          <text x="42" y="32" fill="#FACC15" font-family="'Outfit', sans-serif" font-weight="900" font-size="24">9</text>
          <rect x="8" y="38" width="44" height="12" rx="3" fill="#2563EB"/>
          <text x="30" y="47" fill="#FFFFFF" font-family="'Noto Sans Gujarati', sans-serif" font-weight="700" font-size="8" text-anchor="middle">ગુજરાતી</text>
        </svg>
      `;
    case 'news24':
      return `
        <svg viewBox="0 0 60 60" width="42" height="42" class="channel-logo-img">
          <rect width="60" height="60" rx="14" fill="#1C1917"/>
          <circle cx="30" cy="30" r="24" fill="none" stroke="#DC2626" stroke-width="3" stroke-dasharray="4 2"/>
          <circle cx="30" cy="30" r="18" fill="#DC2626"/>
          <text x="30" y="34" fill="#FFFFFF" font-family="'Outfit', sans-serif" font-weight="900" font-size="12" text-anchor="middle">24/7</text>
          <text x="30" y="44" fill="#FACC15" font-family="'Noto Sans Gujarati', sans-serif" font-weight="700" font-size="7" text-anchor="middle">ગુજરાત</text>
        </svg>
      `;
    case 'sports':
      return `
        <svg viewBox="0 0 60 60" width="42" height="42" class="channel-logo-img">
          <rect width="60" height="60" rx="14" fill="#0C4A6E"/>
          <path d="M18 16h24v12a12 12 0 0 1-24 0V16zm0 4H12a4 4 0 0 0 4 4h2zm24 0h6a4 4 0 0 1-4 4h-2zm-12 16v6m-8 0h16" stroke="#38BDF8" stroke-width="3" stroke-linecap="round" fill="none"/>
          <text x="30" y="52" fill="#F0F9FF" font-family="'Outfit', sans-serif" font-weight="800" font-size="8" text-anchor="middle" letter-spacing="1">SPORTS</text>
        </svg>
      `;
    case 'movies':
      return `
        <svg viewBox="0 0 60 60" width="42" height="42" class="channel-logo-img">
          <rect width="60" height="60" rx="14" fill="#451A03"/>
          <circle cx="30" cy="26" r="14" fill="#D97706"/>
          <polygon points="27,20 37,26 27,32" fill="#FEF3C7"/>
          <text x="30" y="50" fill="#FBBF24" font-family="'Outfit', sans-serif" font-weight="800" font-size="8" text-anchor="middle" letter-spacing="1">CINEMA</text>
        </svg>
      `;
    case 'music':
      return `
        <svg viewBox="0 0 60 60" width="42" height="42" class="channel-logo-img">
          <rect width="60" height="60" rx="14" fill="#4C1D95"/>
          <path d="M22 36a4 4 0 1 0 4-4V18l14-3v17a4 4 0 1 0 4-4V12L22 16v20z" fill="#C084FC"/>
          <text x="30" y="52" fill="#E9D5FF" font-family="'Outfit', sans-serif" font-weight="800" font-size="8" text-anchor="middle">MUSIC</text>
        </svg>
      `;
    case 'bhakti':
      return `
        <svg viewBox="0 0 60 60" width="42" height="42" class="channel-logo-img">
          <rect width="60" height="60" rx="14" fill="#78350F"/>
          <circle cx="30" cy="25" r="13" fill="#F59E0B"/>
          <path d="M30 16c2 3 5 5 5 9a5 5 0 0 1-10 0c0-4 3-6 5-9z" fill="#FEF08A"/>
          <text x="30" y="50" fill="#FDE68A" font-family="'Noto Sans Gujarati', sans-serif" font-weight="700" font-size="8" text-anchor="middle">ભક્તિ</text>
        </svg>
      `;
    default:
      return `
        <svg viewBox="0 0 60 60" width="42" height="42" class="channel-logo-img">
          <rect width="60" height="60" rx="14" fill="#1E293B"/>
          <rect x="3" y="3" width="54" height="54" rx="11" fill="none" stroke="${color}" stroke-width="2"/>
          <circle cx="30" cy="26" r="14" fill="${color}" opacity="0.3"/>
          <text x="30" y="33" fill="#FFFFFF" font-family="'Outfit', sans-serif" font-weight="800" font-size="18" text-anchor="middle">${initial}</text>
          <text x="30" y="49" fill="#94A3B8" font-family="'Outfit', sans-serif" font-weight="600" font-size="7" text-anchor="middle">BHADKO</text>
        </svg>
      `;
  }
}

/**
 * Returns a high-definition simulated broadcast thumbnail frame matching the screenshots!
 */
export function getChannelPosterSvg(channel) {
  const isNews = channel.category === 'News';
  const isSports = channel.category === 'Sports';
  const isMovies = channel.category === 'Movies';
  const isMusic = channel.category === 'Music';

  if (isNews) {
    // Exact match for the studio frame in the screenshots with anchor, temple skyline, ticker tape
    return `
      <div class="poster-news-container">
        <svg viewBox="0 0 640 360" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" class="broadcast-frame-svg">
          <defs>
            <linearGradient id="bgStudioGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#1B2236"/>
              <stop offset="50%" stop-color="#111827"/>
              <stop offset="100%" stop-color="#0A0E17"/>
            </linearGradient>
            <linearGradient id="screenWall" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#1E3A8A"/>
              <stop offset="100%" stop-color="#2563EB"/>
            </linearGradient>
            <linearGradient id="tickerRed" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#DC2626"/>
              <stop offset="100%" stop-color="#B91C1C"/>
            </linearGradient>
          </defs>

          <!-- Studio Background -->
          <rect width="640" height="360" fill="url(#bgStudioGrad)"/>
          
          <!-- Background LED Video Wall with Somnath/Dwarka Temple silhouette -->
          <rect x="40" y="25" width="560" height="240" rx="10" fill="url(#screenWall)" opacity="0.85"/>
          <!-- Grid lines on video wall -->
          <line x1="200" y1="25" x2="200" y2="265" stroke="#3B82F6" stroke-width="2" opacity="0.6"/>
          <line x1="440" y1="25" x2="440" y2="265" stroke="#3B82F6" stroke-width="2" opacity="0.6"/>
          
          <!-- Gujarati News Studio Typography on wall (Left & Right) -->
          <g transform="translate(60, 60)">
            <!-- Left TV9 Gujarati style logo -->
            <rect width="80" height="50" rx="8" fill="#DC2626"/>
            <text x="20" y="32" fill="#FFFFFF" font-family="'Outfit', sans-serif" font-weight="900" font-size="24">TV</text>
            <text x="56" y="34" fill="#FACC15" font-family="'Outfit', sans-serif" font-weight="900" font-size="28">9</text>
            <rect y="48" width="80" height="20" rx="4" fill="#1D4ED8"/>
            <text x="40" y="62" fill="#FFFFFF" font-family="'Noto Sans Gujarati', sans-serif" font-weight="700" font-size="12" text-anchor="middle">ગુજરાતી</text>
          </g>

          <g transform="translate(420, 65)">
            <text x="0" y="30" fill="#FFFFFF" font-family="'Noto Sans Gujarati', sans-serif" font-weight="900" font-size="36" filter="drop-shadow(0 2px 4px rgba(0,0,0,0.5))">ગુજરાત</text>
            <text x="0" y="70" fill="#FFFFFF" font-family="'Noto Sans Gujarati', sans-serif" font-weight="900" font-size="34">મુખ્ય સમાચાર</text>
          </g>

          <!-- Temple Spire Illustration in Center/Background -->
          <path d="M300 130L310 90L315 70L320 90L330 130L340 160L290 160Z" fill="#93C5FD" opacity="0.4"/>
          <line x1="315" y1="65" x2="315" y2="50" stroke="#FBBF24" stroke-width="2"/>
          <polygon points="315,50 325,54 315,58" fill="#F97316"/>

          <!-- News Anchor Graphic (Professional Stylized Silhouette) -->
          <g transform="translate(230, 70)">
            <!-- Head & hair -->
            <ellipse cx="65" cy="55" rx="26" ry="32" fill="#1E293B"/>
            <ellipse cx="65" cy="58" rx="22" ry="26" fill="#FBD38D"/>
            <!-- Hair styling -->
            <path d="M42 55C42 30 50 24 65 24C80 24 88 30 88 55C88 68 85 80 82 90C80 82 76 68 76 68C76 68 72 75 65 75C58 75 54 68 54 68C54 68 50 82 48 90C45 80 42 68 42 55Z" fill="#0F172A"/>
            <!-- Face details -->
            <circle cx="58" cy="56" r="2.5" fill="#1E293B"/>
            <circle cx="72" cy="56" r="2.5" fill="#1E293B"/>
            <path d="M62 67C64 69 66 69 68 67" stroke="#DC2626" stroke-width="2" stroke-linecap="round"/>
            <circle cx="65" cy="52" r="1.5" fill="#B91C1C"/>
            <!-- Blazer / Outfit -->
            <path d="M25 150L45 92L65 110L85 92L105 150L65 160Z" fill="#581C87"/>
            <polygon points="52,94 65,115 78,94" fill="#FFFFFF"/>
            <!-- Anchor Desk curved glass edge -->
            <path d="M-60 170 Q65 140 190 170 L200 230 L-70 230 Z" fill="#0F172A" stroke="#38BDF8" stroke-width="1.5"/>
          </g>

          <!-- BREAKING NEWS chyron header -->
          <g transform="translate(40, 245)">
            <rect width="180" height="26" rx="4" fill="url(#tickerRed)"/>
            <text x="90" y="18" fill="#FFFFFF" font-family="'Outfit', sans-serif" font-weight="900" font-size="14" text-anchor="middle" letter-spacing="1.5">BREAKING NEWS</text>
          </g>

          <!-- Main Lower Third Headline Bar -->
          <g transform="translate(40, 271)">
            <rect width="560" height="42" fill="#FFFFFF"/>
            <text x="25" y="28" fill="#0F172A" font-family="'Noto Sans Gujarati', sans-serif" font-weight="800" font-size="18">રાજ્યમાં આગામી 2 દિવસ ભારે વરસાદની આગાહી</text>
          </g>

          <!-- Sub-ticker tape bar with districts and clock -->
          <g transform="translate(40, 313)">
            <rect width="100" height="30" fill="#DC2626"/>
            <text x="50" y="20" fill="#FFFFFF" font-family="'Noto Sans Gujarati', sans-serif" font-weight="800" font-size="13" text-anchor="middle">ગુજરાત</text>

            <rect x="100" y="0" width="380" height="30" fill="#0B1329"/>
            <text x="115" y="20" fill="#F8FAFC" font-family="'Noto Sans Gujarati', sans-serif" font-weight="600" font-size="11">■ વડોદરા, છોટાઉદેપુર, નર્મદા અને ડાંગ જિલ્લામાં ભારે વરસાદની શક્યતા</text>

            <rect x="480" y="0" width="80" height="30" fill="#0F172A"/>
            <text x="520" y="21" fill="#FACC15" font-family="'Outfit', sans-serif" font-weight="700" font-size="14" text-anchor="middle">08:42</text>
          </g>
        </svg>
      </div>
    `;
  }

  if (isSports) {
    return `
      <div class="poster-sports-container">
        <svg viewBox="0 0 640 360" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" class="broadcast-frame-svg">
          <defs>
            <linearGradient id="sportsGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#0284C7"/>
              <stop offset="60%" stop-color="#0369A1"/>
              <stop offset="100%" stop-color="#075985"/>
            </linearGradient>
          </defs>
          <rect width="640" height="360" fill="url(#sportsGrad)"/>
          <!-- Stadium floodlights & grass pitch glow -->
          <circle cx="320" cy="180" r="140" fill="#38BDF8" opacity="0.25"/>
          <path d="M0 240Q320 200 640 240L640 360L0 360Z" fill="#15803D" opacity="0.6"/>
          <!-- Center trophy icon with glow -->
          <g transform="translate(280, 100) scale(1.4)">
            <path d="M12 4h36v18a18 18 0 0 1-36 0V4zm0 6H4a6 6 0 0 0 6 6h2zm36 0h8a6 6 0 0 1-6 6h-2zm-18 24v8m-12 0h24" stroke="#FDE047" stroke-width="3" stroke-linecap="round" fill="none"/>
            <circle cx="30" cy="15" r="4" fill="#FDE047"/>
          </g>
          <!-- Live Match Scorebug bar -->
          <g transform="translate(60, 270)">
            <rect width="520" height="48" rx="8" fill="#0F172A" stroke="#0284C7" stroke-width="2"/>
            <text x="30" y="30" fill="#FFFFFF" font-family="'Outfit', sans-serif" font-weight="900" font-size="18">GUJARAT TITANS</text>
            <text x="240" y="30" fill="#38BDF8" font-family="'Outfit', sans-serif" font-weight="800" font-size="14">VS</text>
            <text x="310" y="30" fill="#FFFFFF" font-family="'Outfit', sans-serif" font-weight="900" font-size="18">MUMBAI</text>
            <rect x="440" y="10" width="60" height="28" rx="4" fill="#DC2626"/>
            <text x="470" y="29" fill="#FFFFFF" font-family="'Outfit', sans-serif" font-weight="800" font-size="12" text-anchor="middle">LIVE</text>
          </g>
        </svg>
      </div>
    `;
  }

  if (isMovies) {
    return `
      <div class="poster-movies-container">
        <svg viewBox="0 0 640 360" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" class="broadcast-frame-svg">
          <defs>
            <linearGradient id="movieGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#78350F"/>
              <stop offset="50%" stop-color="#451A03"/>
              <stop offset="100%" stop-color="#1E1B4B"/>
            </linearGradient>
          </defs>
          <rect width="640" height="360" fill="url(#movieGrad)"/>
          <g transform="translate(270, 90) scale(1.6)">
            <!-- Cinema Projector Film Reel -->
            <circle cx="30" cy="30" r="26" fill="none" stroke="#D97706" stroke-width="4"/>
            <circle cx="30" cy="30" r="8" fill="#F59E0B"/>
            <circle cx="30" cy="14" r="4" fill="#F59E0B"/>
            <circle cx="30" cy="46" r="4" fill="#F59E0B"/>
            <circle cx="14" cy="30" r="4" fill="#F59E0B"/>
            <circle cx="46" cy="30" r="4" fill="#F59E0B"/>
          </g>
          <g transform="translate(60, 250)">
            <text x="260" y="30" fill="#FEF3C7" font-family="'Noto Sans Gujarati', sans-serif" font-weight="900" font-size="28" text-anchor="middle">છેલ્લો શો (Chhello Show)</text>
            <text x="260" y="60" fill="#FBBF24" font-family="'Outfit', sans-serif" font-weight="600" font-size="15" text-anchor="middle">STARTING TODAY AT 2:30 PM</text>
          </g>
        </svg>
      </div>
    `;
  }

  // Default / Music / Devotional / Education frame
  return `
    <div class="poster-generic-container">
      <svg viewBox="0 0 640 360" width="100%" height="100%" preserveAspectRatio="xMidYMid slice" class="broadcast-frame-svg">
        <defs>
          <linearGradient id="genGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#1E293B"/>
            <stop offset="100%" stop-color="#0F172A"/>
          </linearGradient>
        </defs>
        <rect width="640" height="360" fill="url(#genGrad)"/>
        <circle cx="320" cy="160" r="80" fill="${channel.logoColor || '#FF6B00'}" opacity="0.15"/>
        <g transform="translate(320, 160) scale(1.8)">
          <circle cx="0" cy="0" r="25" fill="${channel.logoColor || '#FF6B00'}" opacity="0.3"/>
          <polygon points="-6,-10 10,0 -6,10" fill="#FFFFFF"/>
        </g>
        <text x="320" y="270" fill="#FFFFFF" font-family="'Outfit', sans-serif" font-weight="800" font-size="24" text-anchor="middle">${channel.name}</text>
        <text x="320" y="300" fill="#94A3B8" font-family="'Noto Sans Gujarati', sans-serif" font-weight="600" font-size="16" text-anchor="middle">${channel.gujaratiName || ''}</text>
      </svg>
    </div>
  `;
}
